import { useTranslation } from "react-i18next";
import { timelineItems } from "../../../mocks/process";

export default function TimelineSection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-graphite">
      <div className="container-main px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 bg-champagne/15 text-champagne text-base md:text-base font-semibold tracking-wider rounded-full mb-4">
            {t("process.timeline.label")}
          </span>
          <h2 className="text-cream mb-3">{t("process.timeline.title")}</h2>
        </div>

        {/* Desktop: Table */}
        <div className="hidden md:block">
          <div className="overflow-hidden rounded-xl border border-warm-gray/20">
            <table className="w-full text-left">
              <thead>
                <tr className="bg-slate-blue/50">
                  <th className="px-6 py-4 text-base font-semibold text-cream/70 uppercase tracking-wider w-16">
                    階段
                  </th>
                  <th className="px-6 py-4 text-base font-semibold text-cream/70 uppercase tracking-wider">
                    服務內容
                  </th>
                  <th className="px-6 py-4 text-base font-semibold text-cream/70 uppercase tracking-wider">
                    預估時程
                  </th>
                </tr>
              </thead>
              <tbody>
                {timelineItems.map((item, index) => (
                  <tr
                    key={item.id}
                    className={`border-t border-warm-gray/10 ${
                      index % 2 === 0 ? "bg-graphite" : "bg-slate-blue/20"
                    } transition-colors hover:bg-slate-blue/30`}
                  >
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-champagne/15 text-champagne text-base font-bold">
                        {String(item.id).padStart(2, "0")}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-base font-medium text-cream">
                      {t(item.phaseKey)}
                    </td>
                    <td className="px-6 py-4 text-base text-cream/70">
                      {t(item.timeKey)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Mobile: Cards */}
        <div className="md:hidden space-y-3">
          {timelineItems.map((item) => (
                <div
                  key={item.id}
                  className="bg-slate-blue/20 rounded-lg p-4 border border-warm-gray/10 transition-all duration-300 hover:border-champagne/30 hover:bg-slate-blue/30"
                >
                  <div className="flex items-center gap-3 mb-2">
                    <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-champagne/15 text-champagne text-base font-bold shrink-0">
                      {String(item.id).padStart(2, "0")}
                    </span>
                    <span className="text-base font-medium text-cream">
                      {t(item.phaseKey)}
                    </span>
                  </div>
                  <p className="text-base text-cream/70 pl-10">
                    {t(item.timeKey)}
                  </p>
                </div>
              ))}
        </div>

        <div className="mt-6 flex items-start gap-2 text-base text-cream/50">
          <span className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
            <i className="ri-information-line" />
          </span>
          <p>{t("process.timeline.note")}</p>
        </div>
      </div>
    </section>
  );
}